import 'dotenv/config';

let BASE_URL = process.env.REACT_APP_API_DEV_URL;
const { NODE_ENV } = process.env;

if (NODE_ENV.toLowerCase() === 'staging') {
    BASE_URL = `${process.env.REACT_APP_API_STAGING_URL}`;
} else if (NODE_ENV.toLowerCase() === 'production') {
    BASE_URL = `${process.env.REACT_APP_API_PROD_URL}`;
} else {
    BASE_URL = `${process.env.REACT_APP_API_DEV_URL}`;
}

async function CreateUserAuth(token: string, email:string, firebase_uid:string) {
    const query = `mutation createUserAuth($email: String!, $firebase_uid: String!) {
        createUserAuth(email: $email, firebase_uid: $firebase_uid){
            success 
            message
        }
    }`;
    const user = await fetch(`${BASE_URL}/graphql`, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'bearer ' + token 
        },
        body: JSON.stringify({
            query,
        variables: {
            email: email,
            firebase_uid: firebase_uid
        }})})
        .then(r => r.json())
    return user;
}

const updateLearningProgress = async (uid: string, pathId: string) => {
    const options = {
        method: 'POST',
        body: JSON.stringify({
            uid,
            pathId
        })
    };
    return await (await fetch(`${BASE_URL}/trackLearnClick`, options)).json();
};

const getUser = async (uid: string, pathId: string) => {
    const options = {
        method: 'GET'
    };
    return await (await fetch(`${BASE_URL}/${uid}`, options)).json();
};

const createUserByFirebaseAuthId = async (
    name: string,
    email: string,
    password: string,
    cid: string,
    profileId: string
) => {
    const options = {
        method: 'POST',
        body: JSON.stringify({
            name,
            email,
            password,
            cid,
            profileId
        })
    };
    return await (await fetch(`${BASE_URL}/`, options)).json();
};

const updateUserByFirebaseAuthId = async (
    cid: string,
    profileId: string,
    email: string,
    name: string,
    phoneNumber: string,
    marketingOptIn: number,
    uid: string
) => {
    const options = {
        method: 'PATCH',
        body: JSON.stringify({
            cid,
            profileId,
            email,
            name,
            phoneNumber,
            marketingOptIn
        })
    };
    return await (await fetch(`${BASE_URL}/${uid}`, options)).json();
};

export { updateLearningProgress, getUser, createUserByFirebaseAuthId, updateUserByFirebaseAuthId, CreateUserAuth };
